/**
 * This store module used to store various button related data into
 * vuex store like tab_button, polk_button etc
 */
/* eslint-disable */
const state = {
  navbuttonsData: [],
  finalNavData: [],
  continueButtonData: [],
  errorPage: null,
  isRc2NavFlow: false,
  navStatus: {
    page_name: null,
    status: '',
  },
};
  
  /* eslint no-shadow: ["error", { "allow": ["state"] }] */
const getters = {
  navbuttonsData(state) {
    return state.navbuttonsData;
    },
  finalNavData(state) {
    return state.finalNavData
   },
   getRc2NavFlow(state) {
    return state.isRc2NavFlow;
  },
  continueButtonData(state) {
    return state.continueButtonData;
    },
  getNavStatus(state) {
    return state.navStatus;
  },
  geterrorPage(state){
    return state.errorPage;
  },
  };
  
const mutations = {
  /**
  * Set button data in vuex store
  * @param {*} state vuex state
  * @param {*} navbuttonsData buttonData form pageData object
  * @param {*} rcstatus
  */
  setNavButtonData(state, pagebuttonsData) {
    Object.assign(state.navbuttonsData,pagebuttonsData);
    },
  setfinalNavData(state, mergeNavData) {
    state.finalNavData =[...mergeNavData];
    },
  setRc2NavFlow(state, rcstatus) {
      state.isRc2NavFlow = rcstatus;
    },
  setErrorPage(state, errorPageName) {
      state.errorPage = errorPageName;
    },
  setcontinueButtonData(state, continueButtonJson) {
    state.continueButtonData = continueButtonJson;
    },
  setNavStatus(state, navStatuses) {
    //console.log('setNavStatus called',navStatuses);
    let fromNav = navStatuses[0];
    let toNav = navStatuses[1];
    state.finalNavData.forEach( nav=>{
     if(nav.name === fromNav.page_name){
        nav.status=fromNav.status;  
      if(fromNav.page_name == 'hopolicydetails')
        sessionStorage.setItem('frmhopolicynavstatus',nav.status);
      if(fromNav.page_name == 'hocheckout' && toNav.page_name !=='hoconfirmation')
        nav.status='Disabled'
     
       }
     if(nav.name === toNav.page_name){
        if(nav.status ==='InactiveFirstTime')
          nav.status='ActiveFirstTime'
        else if(nav.status ==='InactiveIncomplete')
          nav.status='ActiveIncomplete'
        else if(nav.status ==='InactiveComplete')
           nav.status='ActiveComplete'
        else if(nav.status ==='Disabled')
           nav.status='ActiveFirstTime'
       }
     
     });
     sessionStorage.setItem('setfinalNavDataAction',JSON.stringify(state.finalNavData));
  },
  toggleStatuses(state, tobeEnabledNav) {
    // enable only one tab passed into argument
   const getStatus=state.navStatus.status;
   const getNav=state.navStatus.page_name;
   console.log('Page for nav  getStatus',getStatus);
   console.log('Page for nav  previous nav',getNav);
   console.log('Page for nav  current',tobeEnabledNav);
   
   state.finalNavData.forEach( nav=>{
     if(nav.name === getNav){
        nav.status=getStatus;  
        console.log('nav.name',nav.name);
      }
      if(nav.name === tobeEnabledNav){
        if(nav.status ==='InactiveFirstTime')
          nav.status='ActiveFirstTime'
        else if(nav.status ==='InactiveIncomplete')
         nav.status='ActiveIncomplete'
        else if(nav.status ==='InactiveComplete')
         nav.status='ActiveComplete'
      }
    });
  },
   changeContinueButton(state,pagename){
    const TotalLengthOfNavs= state.finalNavData.length;
    for(var index=0; index<state.finalNavData.length; index++)
     {if(state.finalNavData[index].name===pagename)
      { state.continueButtonData[0].pageName=pagename;
        if(index<TotalLengthOfNavs-1)
        {
          state.continueButtonData[0].label=`Save & Continue to ${state.finalNavData[++index].label}`;
          state.continueButtonData[0].routeTo=state.finalNavData[index].name;
        }
        else
        {
          state.continueButtonData[0].label='Save & Continue to Checkout';
          //giving temp for QA  hocoverage
          //state.continueButtonData[0].routeTo='/Property/hocoverage/tp';
          state.continueButtonData[0].routeTo='/Property/hocheckout/tp';
        }
      }
     
    }
  }
  };


  
const actions = {
    /**
     * call setButtonData mutation to store button data in vuex store
     * @param {*} pageData pageData from page API response
     */
  setNavButtonDataAction({ commit }, pageData) {
    commit('setNavButtonData', pageData);
  },
  setfinalNavDataAction({ commit }, mergeNavData) {
    commit('setfinalNavData', mergeNavData);
  },
  setRc2NavFlowAction({ commit }, rcstatus) {
    commit('setRc2NavFlow', rcstatus);
  },
  setErrorPageAction({ commit }, errorPageName) {
    commit('setErrorPage', errorPageName);
  },
  setNavStatusAction({ commit }, navStatus) {
    commit('setNavStatus', navStatus);
  },
  toogleStatusesAction({ commit }, pagename) {
    commit('toggleStatuses', pagename);
  },
  setcontinueButtonDataAction({ commit }, continueButtonlabel) {
    commit('changeContinueButton', continueButtonlabel);
  },
  
};
  
  /**
   * export module to main store.js
   */
  export default {
    state,
    mutations,
    actions,
    getters,
};
  


// WEBPACK FOOTER //
// ./src/store/modules/navbuttonsData.js